'use client';
import React, { useEffect, useState } from 'react';
import { getStats } from '@/lib/gameStore';

export default function StatsBar() {
  const [stats, setStats] = useState({ currentStreak: 0, lifetimeKills: 0, allTimeBest: 0 });

  useEffect(() => {
    const s = getStats();
    setStats(s);
    const handler = () => setStats(getStats());
    window.addEventListener('unbored-stats-update', handler);
    return () => window.removeEventListener('unbored-stats-update', handler);
  }, []);

  return (
    <div className="flex items-center gap-2 flex-wrap justify-center">
      <div className="stat-pill">
        <span>🔥</span>
        <span className="font-mono-nums text-primary">{stats?.currentStreak}</span>
        <span className="text-muted-foreground text-xs">streak</span>
      </div>
      <div className="stat-pill">
        <span>💀</span>
        <span className="font-mono-nums text-secondary">{stats?.lifetimeKills}</span>
        <span className="text-muted-foreground text-xs">killed</span>
      </div>
      <div className="stat-pill">
        <span>🏆</span>
        <span className="font-mono-nums text-gold">{stats?.allTimeBest}</span>
        <span className="text-muted-foreground text-xs">best</span>
      </div>
    </div>
  );
}